module.exports = __webpack_public_path__ + "img/tutorial.e0ac248f.png";